const DownloadIcon = ({
  size = 25,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) => {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 25 24'
        fill='currentColor'
      >
        <path d='M3.03226 14C3.58454 14 4.03226 14.4477 4.03226 15V19C4.03226 19.2652 4.13761 19.5196 4.32515 19.7071C4.51269 19.8946 4.76704 20 5.03226 20H19.0323C19.2975 20 19.5518 19.8946 19.7394 19.7071C19.9269 19.5196 20.0323 19.2652 20.0323 19V15C20.0323 14.4477 20.48 14 21.0323 14C21.5845 14 22.0323 14.4477 22.0323 15V19C22.0323 19.7957 21.7162 20.5587 21.1536 21.1213C20.591 21.6839 19.8279 22 19.0323 22H5.03226C4.23661 22 3.47355 21.6839 2.91094 21.1213C2.34833 20.5587 2.03226 19.7956 2.03226 19V15C2.03226 14.4477 2.47997 14 3.03226 14Z' />
        <path d='M6.32515 9.29289C6.71567 8.90237 7.34884 8.90237 7.73936 9.29289L12.0323 13.5858L16.3252 9.29289C16.7157 8.90237 17.3488 8.90237 17.7394 9.29289C18.1299 9.68342 18.1299 10.3166 17.7394 10.7071L12.7394 15.7071C12.3488 16.0976 11.7157 16.0976 11.3252 15.7071L6.32515 10.7071C5.93463 10.3166 5.93463 9.68342 6.32515 9.29289Z' />
        <path d='M12.0323 2C12.5845 2 13.0323 2.44772 13.0323 3V15C13.0323 15.5523 12.5845 16 12.0323 16C11.48 16 11.0323 15.5523 11.0323 15V3C11.0323 2.44772 11.48 2 12.0323 2Z' />
      </svg>
    </span>
  );
};

export default DownloadIcon;
